export class ComboPessoaFisica {
	id: number;
	nome: string;
	nomeMae: string;
	nomePai: string;
	cpf: string;
}